import rootRoute from '@input-web/configs/route/route.root';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

const uiPlaygroundRoute = createRoute({
  component: lazyRouteComponent(() => import('./ui-playground.view')),
  getParentRoute: () => rootRoute,
  path: '/ui-playground',
});

export default uiPlaygroundRoute;
